import * as React from 'react';
import IconCloseWindow from '@bimser/icons/16/close-window';
import IconSettings from '@bimser/icons/16/settings';
import Style from '../../assets/style.scss';
import IconRefresh from '@bimser/icons/16/refresh';
import { findMessage } from '@bimser/components';

const PanelHeader = (props: {
	closeFlexPanel?: (panelId: string) => void;
	panelGuid?: string;
	handleRefresh?: () => void;
	openSettinsgModal?: () => void;
}) => {
	const onClickClosePanel = () => {
		props.closeFlexPanel?.(props.panelGuid);
	};

	const handleRefresh = () => {
		props.handleRefresh();
	};

	const openSettinsgModal = () => {
		props.openSettinsgModal();
	};

	return (
		<div className={Style.licenceManagerHeader}>
			<div className={Style.headerTitle}>{findMessage.get('103315')}</div>
			<div className={Style.headerEvents}>
				<div className={Style.headerActions}>
					<div className={Style.headerButton}>
						<IconSettings onClick={openSettinsgModal} />
					</div>
					<div className={Style.headerButton}>
						<IconRefresh onClick={handleRefresh} />
					</div>
					<div
						className={[
							Style.customDivider,
							'ant-divider',
							'ant-divider-vertical'
						].join(' ')}
						role="separator"
					></div>
					<div className={Style.headerButton}>
						<IconCloseWindow onClick={onClickClosePanel} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default PanelHeader;
